var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vue-element-loading',{attrs:{"active":_vm.validatignToken,"is-full-screen":""}}),(this.user)?_c('main',[_c('Header'),_c('HeaderBottom'),_c('Filters'),_c('Content'),_c('Footer')],1):_vm._e(),(!this.user)?_c('Login'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }